<template>
  <div class="">
    <!-- 解除绑定 -->
    <el-dialog
      title="Xoá liên kết"
      center
      class="unbind"
      :visible.sync="dialogFormVisible"
      @close="handleClose"
    >
      <el-table
        :data="gridData"
        ref="table"
        style="text-align: center"
        height="400px"
        empty-text="Không có dữ liệu"
      >
        <el-table-column property="username" label="Tài khoản">
        </el-table-column>
        <el-table-column property="account" label="Nguồn"> </el-table-column>
        <el-table-column fixed="right" label="Thao tác">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, gridData)"
              type="text"
              size="small"
            >
              Xoá liên kết
            </el-button>
            <!-- <div v-if="!gridData[scope.$index].primary_account">主账号</div> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      content: "Gửi tin nhắn",
      vipInfo: [],
      gridData: [],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //解除绑定
    handleUnBind() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      this.$http.get("/center/userBindInfo", {}).then((res) => {
        if (res.data.code === 200) {
          let account = [
            "",
            "Email",
            "Chơi ngay",
            "FB",
            "Apple",
            "Huawei",
            "Mobile",
          ];
          res.data.data.forEach((item) => {
            item.account = account[item.account_type];
          });
          this.gridData = res.data.data;
          this.dialogFormVisible = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClose() {
      this.dialogFormVisible = false;
      this.$parent.dialogFormVisible = true;
    },
    deleteRow(index, rows) {
      this.$confirm(
        "Thao tác này sẽ hủy liên kết tài khoản, có tiếp tục không?",
        "Hủy liên kết",
        {
          confirmButtonText: "confirm",
          cancelButtonText: "cancel",
          type: "warning",
        }
      )
        .then(() => {
          let params = {
            username: rows[index].username,
          };
          this.$http.get("/center/unbind", { params }).then((res) => {
            if (res.data.code === 200) {
              console.log(rows[index]);
              rows.splice(index, 1);
              this.$message({
                type: "success",
                message: "Hủy liên kết thành công!",
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Đã xóa hủy liên kết",
          });
        });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  border-radius: 32px !important;
}
/deep/ .cell {
  text-align: center;
}
/deep/ .el-table__fixed,
/deep/ .el-table__fixed-right {
  height: 100% !important;
}
.vip {
  /deep/.el-dialog {
    width: 500px;
    margin-top: 30vh !important;
  }
  /deep/ .el-dialog__body {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  /deep/ .el-button {
    margin-left: 0px;
    margin-bottom: 5px;
  }
}

@media screen and (max-width: 1000px) {
  /deep/.el-dialog {
    width: 90%;
  }
  .vip {
    /deep/.el-dialog {
      width: 90%;
    }
  }
}
</style>
